export const localeStoreTypes = {
  getters: {
    getSelectedLocale: "GET_SELECTED_LOCALE",
    getLocales: "GET_LOCALES",
  },
  actions: {
    setSelectedLocale: "SET_SELECTED_LOCALE",
  },
};
